var backgroundPresets = ['', 'brand-dark', 'brand-light', 'brand-secondary-light', 'emergency-1', 'emergency-2', 'loyalty-dark', 'loyalty-light', 'loyalty-vip', 'promo-1', 'promo-2', 'promo-3', 'promo-4', 'promo-5', 'unbranded-dark', 'unbranded-light'];
var brands = ['', 'corp', 'anf', 'ypb', 'kids', 'hol', 'gh', 'st'];
var verticalSpacingSizes = ['', 'xs', 's', 'm', 'l', 'xl'];
var imageSizes = ['', 'xs', 's', 'm', 'l', 'xl'];
Object.freeze(brands);

export { backgroundPresets, brands, imageSizes, verticalSpacingSizes };
//# sourceMappingURL=constants.js.map
